import React from 'react';

interface Props {
  className?: string;
}

const Grate: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.07143 0.5H0V1.57143V10.5V19.4286V20.5H1.07143H5.71429H10H14.2857H18.9286H20V19.4286V10.5V1.57143V0.5H18.9286H14.2857H10H5.71429H1.07143ZM4.64286 2.64286V9.42857H2.14286V2.64286H4.64286ZM2.14286 11.5714H4.64286V18.3571H2.14286V11.5714ZM6.78571 18.3571V11.5714H8.92857V18.3571H6.78571ZM11.0714 18.3571V11.5714H13.2143V18.3571H11.0714ZM15.3571 18.3571V11.5714H17.8571V18.3571H15.3571ZM17.8571 9.42857H15.3571V2.64286H17.8571V9.42857ZM13.2143 2.64286V9.42857H11.0714V2.64286H13.2143ZM8.92857 2.64286V9.42857H6.78571V2.64286H8.92857Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Grate;
